module.exports = __webpack_public_path__ + "img/Skating_1413_3.9f55be4a.jpg";